import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { Home, Search, Calculator, ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui';

const NotFoundPage = () => {
  const helpfulLinks = [
    { icon: Home, label: 'Go to Homepage', path: '/' },
    { icon: Calculator, label: 'Start Calculating', path: '/' },
    { icon: Search, label: 'View Pricing', path: '/pricing' },
  ];

  return (
    <>
      <Helmet>
        <title>Page Not Found - CalcBuildAI</title>
      </Helmet>

      <div className="min-h-screen bg-gray-50 flex items-center justify-center py-16 px-4">
        <div className="max-w-lg w-full text-center">
          {/* 404 Illustration */}
          <div className="mb-8">
            <div className="text-9xl font-bold text-gray-200">404</div>
            <div className="relative -mt-12">
              <div className="w-24 h-24 bg-blue-100 rounded-full flex items-center justify-center mx-auto">
                <Search className="w-12 h-12 text-blue-600" />
              </div>
            </div>
          </div>

          <h1 className="text-3xl font-bold text-gray-900 mb-4">
            Page Not Found
          </h1>
          <p className="text-gray-600 mb-8">
            Oops! The page you're looking for doesn't exist or has been moved.
            Let's get you back on track.
          </p>

          {/* Primary CTA */}
          <Link to="/">
            <Button size="lg" icon={ArrowLeft}>
              Back to Home
            </Button>
          </Link>

          {/* Helpful Links */}
          <div className="mt-12 pt-8 border-t">
            <p className="text-sm text-gray-500 mb-4">
              Or try one of these:
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              {helpfulLinks.map((link, idx) => (
                <Link
                  key={idx}
                  to={link.path}
                  className="flex items-center gap-2 px-4 py-2 bg-white rounded-lg border hover:border-blue-300 hover:shadow-sm transition-all text-gray-700"
                >
                  <link.icon className="w-4 h-4" />
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          {/* Contact */}
          <p className="mt-8 text-sm text-gray-500">
            Think this is a mistake?{' '}
            <Link to="/contact" className="text-blue-600 hover:underline">
              Let us know
            </Link>
          </p>
        </div>
      </div>
    </>
  );
};

export default NotFoundPage;
